/** Placeholder chip of the cluster pills when no cluster is picked. */
export const ALL_CLUSTERS_OPTION = { id: '__default__', label: 'All Clusters' };

type LoadedCluster = { id: any; label: string };

/**
 * Clusters picked in a cluster pill, as stored in the filters.
 *
 * GenericInfiniteScrollList hands back option objects (autocomplete) or raw ids
 * (list checkbox, "Only" button), so the placeholder and the ids missing from
 * `loadedTags` are dropped whatever their shape: an `undefined` cluster crashes
 * every reader of `filters.tags`.
 */
export const pickedClusters = (selected: any[], loadedTags: LoadedCluster[]): LoadedCluster[] =>
  selected
    .map((item: any) => item?.id ?? item)
    .filter((id: any) => id !== ALL_CLUSTERS_OPTION.id)
    .map((id: any) => loadedTags.find((tag) => tag.id === id))
    .filter((tag): tag is LoadedCluster => tag !== undefined);
